<template>
    <div>
        <div class="search">
            <!-- 筛选 -->
            <my-search :order="2" :inputArr="inputArr" :selectArr="selectArr" timeScreen :searchParams="searchParams" @searchEvent="searchEvent" />
            <el-button type="primary" icon="el-icon-plus" circle class="addBtn" @click="addEnterprise"></el-button>
        </div>

        <el-card shadow="never">
            <myTable :loading="loading" :tableData="tableData" :tableHeader="tableHeader">
                <template v-slot:table_after>
					<el-table-column label="申请材料" align="center" prop="img" width="120">
					    <template slot-scope="{ row }">
							<el-image 
							    class="logo" :src="row.materials | formatImg"
							    :preview-src-list="row.materials | formatImgList">
							  </el-image>
					    </template>
					</el-table-column>
                    <!-- 状态和创建时间 -->
                    <el-table-column label="地址" align="center" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <span>{{row.country?row.country+row.province+row.city+row.distinguish+row.address:'--'}}</span>
                        </template></el-table-column>
                    <el-table-column label="状态" align="center" prop="status">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.status == 2" effect="dark" placement="right">
                                <div slot="content">
                                    {{ scope.row.remark }}
                                </div>
                                <span>
                                    {{ scope.row.status | formatStatus }}
                                </span>
                            </el-tooltip>
                            <span v-else>
                                {{ scope.row.status | formatStatus }}</span>
                        </template></el-table-column>
                    <el-table-column label="更新时间" align="center" prop="updateTime" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="200px" align="center">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="mini" @click="detail(row)">详情</el-button>
                            <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>

                            <el-button type="text" size="mini" @click="examineUnit(row)">{{
                                    ["0", "2"].includes(row.status)
                                        ? "审核"
                                        : row.status == "3"
                                        ? "恢复"
                                        : "冻结"
                                }}</el-button>
                            <el-button type="text" size="mini" @click="deleteitem(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </template>
            </myTable>
            <!-- 分页组件 -->
            <my-pagination :childMsg="pageParams" @callFather="callFather" />
            <!-- 添加、修改组件 -->
            <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :operFormArr="operFormArr" :rules="rules" :selectArrAdd="selectArrAdd" :loading="loading" @submitForm="submitForm" />
            <!-- 详情组件 -->
            <my-dialog-detail :isDialogDetailShow.sync="isDialogDetailShow" :operForm="operForm" :operFormArr="operFormArr" :closeDialog="closeDialog" />
            <!-- 审核对话框 -->
            <auditForm v-if="auditFormVisible" :auditFormVisible.sync="auditFormVisible" @submitForm="submitAuditForm"></auditForm>
        </el-card>
    </div>
</template>

<script>
import {
    reqEnterpriseList,
    reqDelete,
    reqUpdate,
    reqAdd,
    reqExamineUnit,
} from "@/network/content/enterprise";
import mixins from "@/mixins/common";
import auditForm from "@/views/content/channel/auditForm.vue";
import {  baseImg } from "@/common/global.js";
export default {
    name: "enterpriseChannel",
    mixins: [mixins],
    components: { auditForm },
    filters: {
        formatStatus(status) {
            //频道状态：0审核，1正常，2失败，3关闭
            let statusArray = ["待审核", "正常", "失败", "冻结"];
            return statusArray[status];
        },
		formatImg(src) {
		    return `${baseImg}/materials${src}`;
		},
		formatImgList(src) {
			let srcList = [];
			srcList.push(`${baseImg}/materials${src}`)
		    return srcList;
		},
    },
    data() {
        return {
            auditFormVisible: false,
            selectArr: [
                {
                    defaultText: "请选择状态",
                    name: "status",
                    getData: "value",
                    defaultOptions: [
                        //0审核，1正常，2失败，3冻结或暂停
                        { label: "审核", value: 0 },
                        { label: "正常", value: 1 },
                        { label: "失败", value: 2 },
                        { label: "冻结", value: 3 },
                    ],
                },
            ],
            inputArr: [
                {
                    name: "name",
                    defaultText: "请输入企业名称",
                },
            ],
            tableHeader: Object.freeze([
                // {
                //     name: "企业名称",
                //     prop: "name",
                // },
                // {
                //     name: "企业代码",
                //     prop: "creditCode",
                // },
                {
                    name: "企业名称",
                    prop: "name",
                },
                // {
                //     name: "交易等级",
                //     prop: "payLevel",
                // },
                {
                    name: "联系人",
                    prop: "contacts",
                },
                {
                    name: "联系电话",
                    prop: "contactPhone",
                },
                {
                    name: "描述",
                    prop: "description",

                },
            ]),
            searchParams: {
                status: "",
                name: "",
                timeOptions: [],
            },
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: "name",
                    label: "企业名称",
                    defaultText: "请输入企业简称",
                },
                {
                    name: "creditCode",
                    label: "企业代码",
                    defaultText: "请输入企业代码",
                },
                {
                    name: "description",
                    label: "企业描述",
                    defaultText: "请输入登录名",
                },
                {
                    name: "contacts",
                    label: "联系人",
                    defaultText: "请输入联系人",
                },
                {
                    name: "contactPhone",
                    label: "联系电话",
                    defaultText: "请输入联系电话",
                },
                {
                    name: "country",
                    label: "国家",
                    defaultText: "请输入国家",
                },
                {
                    name: "province",
                    label: "省",
                    defaultText: "请输入省",
                },
                {
                    name: "city",
                    label: "市",
                    defaultText: "请输入市",
                },
                {
                    name: "distinguish",
                    label: "区/县",
                    defaultText: "请输入市区/县",
                },
                {
                    name: "address",
                    label: "详细地址",
                    defaultText: "请输入具体地址",
                },
                {
                    name: "payLevel",
                    label: "交易等级",
                    defaultText: "payLevel",
                },
                {
                    name: "materials",
                    label: "申请材料",
                    defaultText: "请添加申请材料",
                },
                {
                    name: "remark",
                    label: "备注",
                    defaultText: "补充内容",
                },
            ],
            selectArrAdd: [
                // {
                //     prop: "authorize", //携带参数的字段
                //     label: "是否授权",
                //     getData: "value", //要展示列表的字段
                //     defaultOptions: [
                //         { label: "授权", value: "1" },
                //         { label: "未授权", value: "2" },
                //     ],
                // },
                // {
                //     prop: "hasUpdate", //携带参数的字段
                //     label: "更日更新",
                //     getData: "value", //要展示列表的字段
                //     defaultOptions: [{ label: "有", value: "1" },
                //     { label: "无", value: "2" },],
                // },
                // {
                //     prop: "type", //携带参数的字段
                //     label: "国内外",
                //     getData: "value", //要展示列表的字段
                //     defaultOptions: [
                //         { label: "国内", value: "1" },
                //         { label: "国外", value: "2" },
                //     ],
                // },
            ],
            //添加、编辑双向绑定值
            operForm: {
                id: "",
                shortName: "",
                description: "",
                authorize: "", //是否授权
                hasUpdate: "", //有无每日更新  1，有每日更新 2，无每日更新
                type: "", //1，国外 2，国内
            },
            // 弹出框的表单验证
            rules: {
                shortName: [
                    {
                        required: true,
                        message: "请输入企业简称",
                        trigger: "blur",
                    },
                ],
                description: [
                    {
                        required: true,
                        message: "请输入企业描述",
                        trigger: "blur",
                    },
                ],
                authorize: [
                    {
                        required: true,
                        message: "请输入是否授权",
                        trigger: "blur",
                    },
                ],
                hasUpdate: [
                    {
                        required: true,
                        message: "请输入有无每日更新",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请输入国内外",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        async getInitData(isSearch) {
            let { timeOptions, status, name } = this.searchParams;
            let params = {
                data: {
                    status,
                    name,
                },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let { data } = await reqEnterpriseList(params);
            if (data.code == 200) {
                data.data.records.map((item) => {
                    item.hasUpdate = item.hasUpdate == 1 ? "有" : "无";
                });
                this.loading = false;
                this.tableData = data.data.records;
                this.pageParams.total = data.data.total;
                if (isSearch) this.pageParams.currentPage = 1;
            }
        },
        //搜索
        searchEvent() {
            this.getInitData(true);
        },
        //  增加企业
        addEnterprise() {
            // 清空
            this.operForm = {};
            this.operTitle = true;
            this.isDialogShow = true;
        },
        // 查
        detail(row) {
            this.isDialogDetailShow = true;
            // 显示
            this.operForm = {
                ...row,
            };
        },
        // 修改
        edit(row) {
            this.operTitle = false;
            this.isDialogShow = true;
            // 显示
            this.operForm = {
                ...row,
            };
        },
        // 确认修改
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let api = operTitle ? reqAdd : reqUpdate;
                let { data } = await api(this.operForm);
                console.log(data);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        // 删除
        deleteitem(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await reqDelete(row.id);
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
        submitAuditForm(val) {
            const params = {
                id: this.id,
                status: val.status,
                remark: val.examineDescribe,
            };
            this.operate(params);
        },
        // 企业操作  审核冻结等
        examineUnit(row) {
            //审核
            if (row.status == 0 || row.status == 2) {
                this.auditFormVisible = true;
                this.id = row.id;
                return;
            }
            const params = {
                id: row.id,
                status: row.status == 3 ? 1 : 3,
            };
            // 关闭
            if (row.status == 1) {
                this.$confirm("关闭禁用当前企业, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.operate(params);
                    })
                    .catch(() => { });
                return;
            }
            //开启
            if (row.status == 3) {
                this.operate(params);
                return;
            }
        },
        async operate(params) {
            let { data } = await reqExamineUnit(params);
            if (data.code == 200) {
                this.$message.success("操作成功");
                this.auditFormVisible = false;
                this.getInitData();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    height: 100px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    padding: 0 30px;
}
.addBtn {
    margin: 0 0 10px 20px;
}
.logo {
	/deep/ img{
		width: 40px;
		height: 40px;
	}
    
}
</style>